import { gql } from '@apollo/client'

export const CREATE_OR_UPDATE_DEMOGRAPHIC_DATA = gql`
  mutation createOrUpdateDemographicData(
    $input: CreateOrUpdateDemographicDataInput!
  ) {
    createOrUpdateDemographicData(input: $input) {
      demographicData {
        id
      }
    }
  }
`
